<template>
  <div id="vision" class="mb-5">
    <div class="card mb-3 mt-3">
      <div class="card-body">
        <h4 class="text-center">{{ translate('suppliers.vision') }}</h4>
        <div v-html="ourVision" class="container"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Vision",
  props: {
    data: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      ourVision: ""
    };
  },
  mounted() {
    this.ourVision = this.data;
  }
};
</script>
<style scoped lang="scss">
.container {
  white-space: pre-wrap;
  word-wrap: break-word;
}
</style>